<div id="promo-wrapper">
    <section id="promo" class="mt-4 mb-4">
        <div class="container dark">
            <div class="row align-items-center text-start">
                <div class="col-7 col-12-narrower">
                    <div class="eyebrow" i18n>Webseiten mit TYPO3</div>
                    <header>
                        <h2 i18n>Professionelle TYPO3-Webseiten, die langfristig funktionieren</h2>
                    </header>
                    <p class="lead" i18n>Wir entwickeln, modernisieren und pflegen <strong>TYPO3-Webseiten für Unternehmen</strong> – technisch zuverlässig, gut auffindbar und einfach redaktionell zu betreuen.</p>
                    <p i18n>Von der neuen Unternehmenswebseite über den Relaunch bis zur laufenden TYPO3-Pflege erhalten Sie bei AlbCode aus Hechingen eine persönliche Betreuung und eine Lösung, die zu Ihren Inhalten, Zielgruppen und Arbeitsabläufen passt.</p>
                </div>
                <div class="col-5 col-12-narrower">
                    <div class="visual-frame hero-preview">
                        <img src="/freepics/coding.jpg" width="512" height="251" fetchpriority="high" alt="Entwicklung einer modernen TYPO3-Unternehmenswebseite" i18n-alt />
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<div class="wrapper">
    <section class="container">
        <header class="major text-center">
            <h2 i18n>TYPO3-Leistungen aus einer Hand</h2>
            <p i18n>Für neue Webseiten, bestehende Installationen und die langfristige technische Betreuung.</p>
        </header>
        <div class="row features g-4">
            <section class="col-4 col-12-narrower feature text-start">
                <div class="service-card">
                    <span class="icon featured fa-solid fa-window-maximize"></span>
                    <h3 i18n>Webseite und Relaunch</h3>
                    <p i18n>Konzeption und Umsetzung responsiver TYPO3-Webseiten mit individuellen Inhaltsbereichen, verständlicher Navigation und einem Auftritt, der zu Ihrem Unternehmen passt.</p>
                </div>
            </section>
            <section class="col-4 col-12-narrower feature text-start">
                <div class="service-card">
                    <span class="icon featured fa-solid fa-screwdriver-wrench"></span>
                    <h3 i18n>Wartung und Pflege</h3>
                    <p i18n>TYPO3-Updates, Sicherheitsaktualisierungen, Fehlerbehebung und technische Weiterentwicklung für einen stabilen und verlässlichen Betrieb.</p>
                </div>
            </section>
            <section class="col-4 col-12-narrower feature text-start">
                <div class="service-card">
                    <span class="icon featured fa-solid fa-magnifying-glass-chart"></span>
                    <h3 i18n>SEO und Performance</h3>
                    <p i18n>Saubere Seitenstrukturen, schnelle Ladezeiten, suchfreundliche Inhalte und technische Grundlagen für klassische Suchmaschinen und KI-gestützte Suche.</p>
                </div>
            </section>
        </div>
    </section>
</div>

<div class="wrapper">
    <section class="container text-start">
        <div class="row align-items-stretch g-5">
            <div class="col-7 col-12-narrower content-copy">
                <header class="major">
                    <h2 i18n>Ihre Webseite bleibt aktuell und erweiterbar</h2>
                </header>
                <p i18n>Eine gute Unternehmenswebseite ist kein einmaliges Projekt. Wir unterstützen Sie von der ersten Planung bis zur laufenden Pflege und behalten Technik, Inhalte, Auffindbarkeit und Weiterentwicklung gemeinsam im Blick.</p>
                <ul class="service-list">
                    <li i18n>Übernahme und technische Prüfung bestehender TYPO3-Webseiten</li>
                    <li i18n>Individuelle Templates, Inhaltsbausteine und Erweiterungen</li>
                    <li i18n>TYPO3-Upgrades und Migration veralteter Installationen</li>
                    <li i18n>Schnittstellen zu Formularen, CRM und weiteren Systemen</li>
                    <li i18n>Unterstützung bei Inhalten und redaktionellen Abläufen</li>
                    <li i18n>Regelmäßige Wartung und persönliche Ansprechpartner</li>
                </ul>
            </div>
            <div class="col-5 col-12-narrower">
                <div class="visual-frame process-image mb-4">
                    <img src="/freepics/man-holds-smartphone-works-laptop_vertical.jpg" width="683" height="1024" loading="lazy" alt="Pflege einer responsiven TYPO3-Webseite auf Laptop und Smartphone" i18n-alt />
                </div>
                <div class="callout">
                    <h3 i18n>Bestehende TYPO3-Webseite?</h3>
                    <p i18n>Wir prüfen den technischen Stand und zeigen verständlich, welche Maßnahmen sinnvoll sind.</p>
                    <div class="cta-actions">
                        <a routerLink="/contact" class="glow-on-hover p-3" i18n>Webseite prüfen lassen</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<div class="wrapper faq-wrapper">
    <section class="container text-start">
        <header class="major text-center">
            <h2 i18n>Häufige Fragen zu TYPO3</h2>
        </header>
        <div class="faq-grid">
            <article class="faq-item">
                <h3 i18n>Können Sie unsere bestehende TYPO3-Webseite übernehmen?</h3>
                <p i18n>Ja. Wir prüfen Installation, Erweiterungen, Templates und technischen Zustand und schlagen anschließend die passenden nächsten Schritte vor.</p>
            </article>
            <article class="faq-item">
                <h3 i18n>Übernehmen Sie auch die laufende Pflege?</h3>
                <p i18n>Ja. Wir unterstützen bei TYPO3-Updates, Sicherheitsaktualisierungen, Fehlerbehebung, Erweiterungen und der technischen Weiterentwicklung.</p>
            </article>
            <article class="faq-item">
                <h3 i18n>Können wir Inhalte weiterhin selbst pflegen?</h3>
                <p i18n>Ja. Wir richten verständliche Inhaltsbausteine ein und unterstützen Ihr Team auf Wunsch bei der Einarbeitung in die redaktionelle Pflege.</p>
            </article>
        </div>
    </section>
</div>
